// import React
import React, { useState } from "react";

// import Validator
import validator from "validator";

// import Firebase
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

// import Components
import NavigationBar from "../Components/NavigationBar";
import Footer from "../Components/Footer";

// import CSS
import "./Home.css";

const Home = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (validator.isEmail(email)) {
      try {
        await addDoc(collection(db, "mailing-list"), { emailAddress: email });
        setEmail("");
        setSuccess(true);
        setError("");
      } catch (err) {
        setError(err);
      }
    } else {
      setSuccess(false);
      setError("Please enter a valid email address.");
      console.log(error);
    }
  };

  return (
    <div className='home-container'>
      <NavigationBar />
      <img
        src='/images/overload_logo_white.png'
        alt='Overload Events Logo'
        className='overload-events-logo'
      />
      <div className='mailing-list-container'>
        {success ? (
          <div className='success-message'>
            You've been added to our mailing list!
          </div>
        ) : (
          <div className='mailing-list-form-container'>
            <form
              className='mailing-list-form'
              onSubmit={(e) => {
                e.preventDefault(); // Prevent default form submission behavior
                handleSubmit(); // Call the handleSubmit function
              }}>
              <input
                type='text'
                className={`email-input ${error ? "error" : ""}`}
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                type='submit' // Specify the type as submit for proper form behavior
                className='submit-button'>
                Join Our Mailing List
              </button>
            </form>

            <div className='mailing-list-terms'>
              By clicking 'Join Our Mailing List,' you agree to receive updates,
              promotional content, and other communications from us. Your
              information will be stored securely. You can unsubscribe at any
              time by contacting us directly.
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Home;
